import { translate } from "app/language/service"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { PageHeader } from "ui/components/main-layout/PageHeader"
import { MediaApprovalList } from "./MediaApprovalList"
import { MediaApprovalListFilters } from "./MediaApprovalListFilters"

export const MediaApprovalListPage = (): JSX.Element => {
  return (
    <FlexBox vertical fullWidth fullHeight ai="start" jc="start" sx={{ animation: "fadeIn 600ms" }}>
      <PageHeader title={translate("media-approval.page.title")} />
      <FlexBox
        fullWidth
        fullHeight
        jc="start"
        ai="start"
        vertical
        gap
        sx={{
          p: "1rem",
          pt: 0
        }}>
        <MediaApprovalListFilters />
        <MediaApprovalList />
      </FlexBox>
    </FlexBox>
  )
}
